<template>
  <app-layout
    title="Customize"
    :version="version"
    :bannerSetting="bannerSetting"
  >
    <template #header>
      <div class="flex h-9">
        <h2
          class="flex-1 font-semibold text-xl leading-tight flex items-center"
        >
          {{ project.domain_name }}
        </h2>
        <div>
          <span
            v-if="lastPath === 'dialogs'"
            class="
              text-sm
              mx-5
              cursor-pointer
              hover:underline
              text-gray-500
              hover:text-gray-700
            "
            @click="openGetScriptModal"
          >
            รับสคริปต์
          </span>
          <jet-button
            class="
              cursor-pointer
              inline-flex
              items-center
              px-4
              py-2
              bg-yr-primary-ii-500
              border border-transparent
              rounded-md
              font-semibold
              text-xs text-white
              uppercase
              tracking-widest
              hover:bg-yr-primary-ii-600
              active:bg-yr-primary-ii-700
              focus:outline-none
              focus:border-yr-primary-ii-700
              focus:ring
              focus:ring-yr-primary-ii-300
              transition
            "
            @click="saveCustomStyle()"
          >
            บันทึกสไตล์
          </jet-button>
        </div>
      </div>
    </template>

    <div class="mx-auto sm:px-6 lg:px-8">
      <div class="text-sm font-medium text-center text-yr-primary-ii-500">
        <ul class="flex flex-wrap -mb-px">
          <li
            v-for="(tabContent, index) in tabsContent"
            :key="index"
            class="mr-2"
          >
            <Link
              :href="route(`projects.${tabContent.link}.index`, project)"
              class="inline-block p-4 rounded-t-lg border-b-[3px]"
              :class="
                tabContent.link === lastPath
                  ? 'font-bold text-yr-primary-ii-700 border-yr-primary-ii-700'
                  : 'border-transparent hover:border-yr-primary-ii-400'
              "
              >{{ tabContent.title }}</Link
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="pb-12">
      <div class="mx-auto sm:px-6 lg:px-8">
        <div
          class="
            p-6
            sm:px-8
            bg-white
            overflow-hidden
            shadow-xl
            sm:rounded-lg
            grid grid-cols-4
            gap-4
            h-[calc(100vh-355px)]
          "
        >
          <div class="col-span-1 overflow-y-auto">
            <!-- start accordion -->
            <div class="accordion" id="accordionDialogs">
              <div class="accordion-item bg-white">
                <h2 class="accordion-header mb-0" id="heading-menu-1">
                  <jet-button
                    class="
                      accordion-custom
                      flex
                      justify-between
                      w-full
                      px-4
                      py-4
                      mb-3
                      text-yr-primary-ii-500
                      border-yr-primary-ii-300
                      hover:bg-yr-primary-500 hover:border-yr-primary-500
                      active:bg-yr-primary-600
                      focus:outline-none
                      focus:border-yr-primary-500
                      focus:bg-yr-primary-500
                      focus:ring-transparent
                      transition
                      bg-transparent
                      collapsed
                    "
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse-menu-1"
                    aria-expanded="true"
                    aria-controls="collapse-menu-1"
                  >
                    <span>1. ภาษาและข้อความ </span>
                    <span class="material-icons arrow-down md-16 transition"
                      >keyboard_arrow_down</span
                    >
                  </jet-button>
                </h2>
                <div
                  id="collapse-menu-1"
                  class="accordion-collapse collapse"
                  aria-labelledby="heading-menu-1"
                  data-bs-parent="#accordionDialogs"
                >
                  <div class="accordion-body pb-4 px-5">
                    <jet-label
                      class="font-normal text-gray-400 text-sm mb-1"
                      for="bannerText"
                      value="เนื้อหา"
                    />
                    <textarea
                      class="
                        w-full
                        font-normal
                        text-gray-500 text-sm
                        bg-white bg-clip-padding
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:bg-white
                        focus:outline-none
                        focus:border-yr-primary-500
                        focus:ring-transparent
                      "
                      ref="bannerText"
                      v-model="customs.bannerText"
                      rows="5"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="accordion-item bg-white">
                <h2 class="accordion-header mb-0" id="heading-menu-2">
                  <jet-button
                    class="
                      accordion-custom
                      flex
                      justify-between
                      w-full
                      px-4
                      py-4
                      mb-3
                      text-yr-primary-ii-500
                      border-yr-primary-ii-300
                      hover:bg-yr-primary-500 hover:border-yr-primary-500
                      active:bg-yr-primary-600
                      focus:outline-none
                      focus:border-yr-primary-500
                      focus:bg-yr-primary-500
                      focus:ring-transparent
                      transition
                      bg-transparent
                      collapsed
                    "
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse-menu-2"
                    aria-expanded="true"
                    aria-controls="collapse-menu-3"
                  >
                    <span>2. นโยบาย </span>
                    <span class="material-icons arrow-down md-16 transition"
                      >keyboard_arrow_down</span
                    >
                  </jet-button>
                </h2>
                <div
                  id="collapse-menu-2"
                  class="accordion-collapse collapse"
                  aria-labelledby="heading-menu-2"
                  data-bs-parent="#accordionDialogs"
                >
                  <div class="accordion-body pb-4 px-5">
                    <jet-label
                      class="font-normal text-gray-400 text-sm mb-1"
                      for="policyName"
                      value="ชนิดของนโยบาย"
                    />
                    <select
                      class="
                        w-full
                        font-normal
                        text-gray-500 text-sm
                        placeholder-gray-300
                        bg-white bg-clip-padding
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        mb-3
                        focus:bg-white
                        focus:outline-none
                        focus:border-yr-primary-500
                        focus:ring-transparent
                      "
                      ref="policyType"
                      v-model="customs.policy.type"
                      @change="setPolicy()"
                    >
                      <option
                        v-for="(policyType, index) in policyTypes"
                        :key="index"
                        :value="policyType.type"
                      >
                        {{ policyType.title }}
                      </option>
                    </select>
                    <jet-label
                      v-if="customs.policy.type === 'custom'"
                      class="font-normal text-gray-400 text-sm mb-1"
                      for="policyName"
                      value="ชื่อของนโยบาย"
                    />
                    <jet-input
                      v-if="customs.policy.type === 'custom'"
                      type="text"
                      class="
                        w-full
                        font-normal
                        text-gray-500 text-sm
                        placeholder-gray-300
                        bg-white bg-clip-padding
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        mb-3
                        focus:bg-white
                        focus:outline-none
                        focus:border-yr-primary-500
                        focus:ring-transparent
                      "
                      placeholder="นโยบายคุกกี้"
                      ref="policyName"
                      v-model="customs.policy.name"
                    />
                    <jet-label
                      class="font-normal text-gray-400 text-sm mb-1"
                      for="policyLink"
                      value="ลิงก์สู่นโยบาย (จำเป็นต้องใส่ protocol)"
                    />
                    <jet-input
                      type="text"
                      class="
                        w-full
                        font-normal
                        text-gray-500 text-sm
                        placeholder-gray-300
                        bg-white bg-clip-padding
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:bg-white focus:outline-none focus:ring-transparent
                      "
                      :class="
                        validURL
                          ? 'focus:border-yr-primary-500'
                          : 'text-red-500 border-red-500 focus:border-red-500'
                      "
                      placeholder="https://www.example.com or http://www.example.com"
                      ref="policyLink"
                      v-model="customs.policy.link"
                      @input="validateURL()"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- end accordion -->
          </div>
          <div
            class="
              col-span-3
              border-l border-yr-primary-ii-200
              pl-4
              bg-yr-primary-50
            "
          >
            <div class="h-full relative">
              <div id="cookiePop-xxx" class="show hidden">
                <img src="/img/logo.png" />
                <p>
                  Our website uses cookies to provide your browsing experience
                  and relevant information. Before continuing to use our
                  website, you agree &amp; accept of our
                  <a href="#">Cookie Policy &amp; Privacy.</a>
                </p>
                <div class="btn-group">
                  <button id="acceptCookie" class="border">
                    Change Preferences
                  </button>
                  <button id="acceptCookie">Accept All</button>
                </div>
              </div>

              <!-- test -->

              <div id="cookiePop" class="show" style="position: absolute">
                <p>
                  {{ customs.bannerText }}
                  <span v-if="customs.policy.link && customs.policy.name"
                    ><a
                      :href="customs.policy.link"
                      class="underline"
                      target="_blank"
                      >{{ customs.policy.name }}</a
                    ></span
                  >
                </p>
                <div class="btnGroup">
                  <button id="selectOptions" class="border">
                    ตั้งค่า Cookies
                  </button>
                  <button id="acceptCookie">ยอมรับทั้งหมด</button>
                </div>
                <div id="cookieOptions">
                  <div class="optionBlock">
                    <div class="cookieOption">
                      <div class="titleBlock">
                        <div class="title">คุกกี้ที่จำเป็นต่อการทำงาน</div>
                        <div class="selectOption textBlue">ปิดไม่ได้</div>
                      </div>
                      <div class="description">
                        เราใช้คุกกี้นี้เพื่อให้เว็บไซต์สามารถทำงานได้
                        รวมไปถึงการจดจำตัวตนของคุณเพื่อเข้าถึงส่วนที่ปลอดภัยของเว็บไซต์
                        ซึ่งหากไม่มีคุกกี้นี้เว็บไซต์จะไม่สามารถใช้งานได้
                        เราจึงไม่สามารถปิดการใช้งานคุกกี้นี้ได้
                      </div>
                    </div>
                    <div class="cookieOption">
                      <div class="titleBlock">
                        <div class="title">คุกกี้สำหรับวิเคราะห์ข้อมูล</div>
                        <div class="selectOption">
                          <label class="switch">
                            <input id="analyticOpt" type="checkbox" />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div class="description">
                        เราใช้คุกกี้นี้เพื่อให้เราเข้าใจรูปแบบการใช้งานของผู้เข้าชมเว็บไซต์
                        ซึ่งจะช่วยให้เราปรับปรุงเว็บไซต์ของเราให้ดีขึ้น
                      </div>
                    </div>
                    <div class="cookieOption">
                      <div class="titleBlock">
                        <div class="title">คุกกี้สำหรับการตลาด</div>
                        <div class="selectOption">
                          <label class="switch">
                            <input id="marketingOpt" type="checkbox" />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div class="description">
                        เราใช้คุกกี้นี้เพื่อติดตามพฤติกรรมของผู้เข้าชมเว็บไซต์เพื่อแสดงโฆษณาที่เหมาะสมกับผู้ใช้งานบนเว็บของเราหรือบนเว็บไซต์ของบุคคลที่สาม
                      </div>
                    </div>
                    <div class="btnGroup">
                      <button id="acceptOptions">ยืนยันตัวเลือก</button>
                    </div>
                  </div>
                </div>
                <div class="poweredBySmallText">
                  Powered by
                  <a href="https://cookiepop.app" target="_blank">CookiePop</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <GetScriptModal
      :projectCode="project.code"
      :baseUrl="base_url"
      :openModal="getScriptModal"
      @close-modal="closeGetScriptModal"
    />
  </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import moment from "moment";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetLabel from "@/Jetstream/Label.vue";
import JetInput from "@/Jetstream/Input.vue";
import { Link } from "@inertiajs/inertia-vue3";
import GetScriptModal from "@/Pages/Consents/Partials/GetScriptModal";
import ToggleButton from "@/Components/ToggleButton";
import "tw-elements";

export default defineComponent({
  props: ["project", "base_url", "version", "bannerSetting"],

  components: {
    AppLayout,
    Link,
    GetScriptModal,
    JetButton,
    JetLabel,
    JetInput,
    ToggleButton,
  },

  data() {
    return {
      getScriptModal: false,
      tabsContent: [
        {
          title: "บันทึกความยินยอม",
          link: "consents",
        },
        {
          title: "สแกนคุกกี้",
          link: "cookies",
        },
        {
          title: "จัดการคุกกี้",
          link: "manage",
        },
        {
          title: "ปรับแต่งแบนเนอร์",
          link: "dialogs",
        },
        // {
        //   title: "ตั้งค่าแบนเนอร์",
        //   link: "banner_setting",
        // },
      ],
      menuCategories: [
        // "โลโก้",
        // "สีและขนาดตัวอักษร",
        // "ตำแหน่ง",
        // "ภาษาและข้อความ",
        // "ปุ่ม",
        // "ปรับแต่งมุมโค้ง",
        // "นโยบาย",
        // "การตั้งค่าคุกกี้",
        // "ปรับแต่ง CSS",
      ],
      customs: {
        bannerText:
          'เราใช้ Cookies บนเว็บไซต์ของเราเพื่อเพิ่มประสิทธิภาพของเว็บไซต์และเพื่อประสบการณ์ที่ดีของผู้ใช้งาน คุณสามารถตั้งค่าการยอมรับ Cookies ได้ที่ปุ่ม "ตั้งค่า Cookies"',
        policy: {
          type: "cookie",
          name: "นโยบายคุกกี้",
          link: "",
        },
        projectId: "",
      },
      policyTypes: [
        {
          type: "cookie",
          title: "นโยบายคุกกี้",
          name: "นโยบายคุกกี้",
        },
        {
          type: "privacy",
          title: "นโยบายความเป็นส่วนตัว",
          name: "นโยบายความเป็นส่วนตัว",
        },
        {
          type: "custom",
          title: "กำหนดเอง",
          name: "นโยบายคุกกี้",
        },
      ],
      validURL: true,
    };
  },

  mounted() {
    const bsCustomize = JSON.parse(this.bannerSetting.customize);
    this.customs.bannerText = bsCustomize.bannerText ?? this.customs.bannerText;
    this.customs.policy = bsCustomize.policy ?? this.customs.policy;
  },

  computed: {
    lastPath() {
      return window.location.pathname.split("/").pop();
    },
  },

  methods: {
    getHumanDate(date) {
      return moment(date).format("YYYY-MM-DD h:mm");
    },
    openGetScriptModal() {
      this.getScriptModal = true;
    },
    closeGetScriptModal() {
      this.getScriptModal = false;
    },
    setPolicy() {
      const policyTypes = this.policyTypes.find(
        (elm) => elm.type === this.customs.policy.type
      );
      this.customs.policy.name = policyTypes.name;
    },
    validateURL() {
      let url = this.customs.policy.link;
      if (url && url.length) {
        let pattern = new RegExp(
          "^(http(s?):\\/\\/)" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
            "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$",
          "i"
        ); // fragment locator
        this.validURL = !!pattern.test(url);
      } else {
        this.validURL = true;
      }
      console.log(this.validURL);
    },
    saveCustomStyle() {
      // store input ข้างต้น
      axios
        .post(route("save.custom.style"), {
          bannerText: this.customs.bannerText,
          policy: this.customs.policy,
          projectId: this.project.id,
        })
        .then(() => window.location.reload())
        .catch((error) => {});
    },
  },
});
</script>

<style lang="css" scoped>
.accordion-custom.collapsed {
  background-color: transparent;
  border-color: #cec6a5;
}
.accordion-custom:not(.collapsed) {
  background-color: #fdd835;
  border-color: #fdd835;
}
.accordion-custom:not(.collapsed) .arrow-down {
  transform: rotate(-180deg);
}
</style>

<style>
#cookiePop {
  background-color: #ffffff;
  /* position: fixed; */
  font-size: 14px;
  width: 70vw;
  max-width: 42.85em;
  box-shadow: 0 0 2em rgba(5, 0, 31, 0.15);
  font-family: "Poppins", sans-serif;
  text-align: justify;
  line-height: 1.8em;
  border-radius: 6px;
  transition: 0.3s all ease-in-out;
  z-index: 1;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-5%);
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: fadeInBottom;
}

#selectOptions {
}

#acceptCookie {
}

.poweredBySmallText {
  background-color: #fff7d3;
  margin-top: 15px;
  padding: 0.5em;
  font-size: 11px;
  text-align: center;
}

@keyframes fadeInBottom {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(100%);
  }
  to {
    opacity: 1;
  }
}

.optionBlock {
  border: 1px solid #cec6a5;
  border-radius: 6px;
  margin: 1.4em;
  padding-bottom: 1.4em;
}

#cookiePop img {
  display: block;
  width: 70px;
  transform: translateZ(0);
  position: relative;
  margin: auto;
}

#cookiePop p {
  text-align: center;
  margin: 1.4em;
}

#cookiePop .btnGroup {
  display: flex;
  justify-content: center;
}

#cookiePop button {
  background-color: #fdd835;
  border: none;
  color: #85711d;
  font-size: 1.2em;
  padding: 0.5rem 1rem;
  display: block;
  position: relative;
  cursor: pointer;
  /* margin: auto; */
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
}

#cookiePop button.border {
  background: transparent;
  border: solid 1px #cec6a5;
}

#cookiePop a {
  color: #85711d;
}

#cookieOptions {
  transition: opacity 1s ease-out;
  opacity: 0;
  height: 0;
  overflow: hidden;
}

.titleBlock {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.title {
  font-weight: bold;
  color: #85711d;
}

.description {
  font-size: 11px;
  margin-top: 0.5em;
}

.show {
  visibility: visible !important;
}

.hide {
  visibility: hidden;
}

.cookieOption {
  margin: 1.4em;
}

#acceptOptions {
  margin: auto;
}

#cookieOptions.active {
  opacity: 1 !important;
  height: auto !important;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.switch input:checked + .slider {
  background-color: #85711d;
}

.switch input:focus + .slider {
  box-shadow: 0 0 1px #85711d;
}

.textBlue {
  color: #85711d;
}

#analyticOpt {
}

#marketingOpt {
}

.switch input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

@media only screen and (max-width: 37.5em) {
  #cookiePop {
    width: 80%;
  }
}
</style>
